import { query, utils } from '@kurtosys/ksys-app-template';
import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IAwardsConfiguration } from '../models';
import { IAwardQueries } from '../models/IAwardQueries';
import { IAwardProps } from '@kurtosys/ksys-app-components/dist/components/overview/Award/models/IAwardProps';
import { IAwardsProps } from '@kurtosys/ksys-app-components/dist/components/overview/Awards/models';
import { IAward } from '@kurtosys/ksys-app-components/dist/components/overview/Awards/models/IAward';

const Query = query.Query;

export class AwardsStore extends StoreBase {
	static componentKey: 'awards' = 'awards';

	@computed
	get configuration(): IAwardsConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration('awards');
		}
	}

	@computed
	get awardQueries(): IAwardQueries | undefined {
		return this.configuration && this.configuration.awardQueries;
	}

	@computed
	get awardsFromQueries(): any[] {
		const awardQueries = this.awardQueries;
		if (awardQueries && awardQueries.awards) {
			const { awards: awardsQuery } = awardQueries;
			const awards = this.getQueryValue(awardsQuery);
			return awards && awards.map((award: any) => this.getAward(award));
		}
		return [];
	}

	getAward(award: any): IAwardProps | undefined {
		const { queryStore } = this.storeContext;
		if (queryStore && this.awardQueries) {
			queryStore.setStatistic(award);
			const { awards, layout, ...fields } = this.awardQueries;
			const result = Query.convertQueryMime(fields, queryStore.executionOptions);
			return {
				...result,
				// Add the award name as the alt text for the image for accessibility
				imageProps: {
					alt: `${ result.name }`
				},
				layout,
			};
		}
	}

	sortBy = (award: IAward) => {
		return award.order && award.order.toString() || '';
	};

	@computed
	get awardsProps(): IAwardsProps | undefined {
		if (this.configuration) {
			const { awardQueries, ...configuration } = this.configuration;
			const awardsProps: IAwardsProps = this.mergeQueriesAndProps(configuration) || {};
			if (!utils.typeChecks.isNullOrEmpty(this.awardsFromQueries)) {
				awardsProps.awards = this.awardsFromQueries;
			}
			awardsProps.sortBy = this.sortBy;
			return awardsProps;
		}
	}

	@computed
	get hasData(): boolean {
		return Array.isArray(this.awardsFromQueries) && this.awardsFromQueries.length > 0;
	}

	@action
	async initialize(): Promise<void> {

	}
}